// Specialty Model

import { Model } from "@vuex-orm/core";

export class ICPC extends Model {
  static entity = 'icpc'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string(),
      chapterId: this.attr(null),
      componentId: this.attr(null),
    }
  }
}

export class ICPCComponent extends Model {
  static entity = 'icpcComponents'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string()
    }
  }
}

export class ICPCChapter extends Model {
  static entity = 'icpcChapters'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string()
    }
  }
}